<template>
<el-container style="height:100vh">
  <el-aside width="200px" style="background:#fff">
    <el-menu router default-active="/home/app">
      <el-menu-item index="/home/app">APP管理</el-menu-item>
      <el-menu-item index="/home/category">分类管理</el-menu-item>
      <el-menu-item index="/home/content">内容管理</el-menu-item>
      <el-menu-item index="/home/user">用户管理</el-menu-item>
      <el-menu-item index="/home/style">样式配置</el-menu-item>
      <el-menu-item index="/home/agreement">协议管理</el-menu-item>
      <el-menu-item index="/login" @click="logout">退出登录</el-menu-item>
    </el-menu>
  </el-aside>
  <el-container>
    <el-header style="background:#fff;border-bottom:1px solid #eee">后台管理系统</el-header>
    <el-main><router-view /></el-main>
  </el-container>
</el-container>
</template>
<script>
export default {
  name: "Home",
  methods: {
    logout() {
      // 清除登录状态
      localStorage.clear()
      
      // 安全跳转到登录页，不报错
      this.$router.replace('/login').catch(() => {})
    }
  }
};
</script>